import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs/internal/Observable';

import { SearchPageStateService, UrlQueryState } from '@stylehaven/components';
import { BaseSandbox } from '../base/base.sandbox.service';

@Injectable()
export abstract class OverviewSandbox extends BaseSandbox {
    // DEPRECATED
    // Do not add any other stuff to this unless it is required in all overviews implementing this sandbox.
    // Even better would be to remove this sandbox altogether and only implement it in those sandboxes that actually need it.

    // Injectors
    protected searchPageStateService: SearchPageStateService = inject(SearchPageStateService);

    // #region Overview state
    public getUrlQueryState(): Observable<UrlQueryState> {
        return this.searchPageStateService.getUrlQueryState();
    }
    // #endregion
}
